export default "__VITE_ASSET__CUeH_A3d__"